import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ProfessionalWork from '../fakeData/ProfessionalWork';
import './../index.css';
import SingleCaseStudy from './SingleCaseStudy';

const ProfessionalWorkSection = () => {
  return (
    <section
      className='portfolio-container professional-work-container'
      name='portfolio'
      id='portfolio'
      data-aos='fade-up'
    >
      <div className='common pt-5'>
        <h2 className='mainHeader mt-5'>Professional Work</h2>
        <p className='mainContent'>
          Case studies from my work leading engineering at Markopolo.ai.
          Details are kept general since this is proprietary work.
        </p>
        <div className='commonBorder' />
      </div>

      <Container>
        <Row>
          {ProfessionalWork.map((work) => (
            <SingleCaseStudy work={work} key={work.id} />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProfessionalWorkSection;
